import React from "react";
import Tooltip from "rc-tooltip";
import "rc-tooltip/assets/bootstrap.css";

export default function paginatedDataTable({
  paginatedData,
  rowsPerPage,
  currentPage,
  totalPages,
  handleRowsPerPageChange,
  handlePageChange,
  handleEmployeeSelection,
  employeeList,
  selectedEmployee,
}) {
  return (
    <div className="pto-table-container bg-white mb-3">
      <div className="pto-table-scroll">
        <table className="pto-table">
          <thead>
            <tr>
              <th style={{ width: "1%" }}></th>
              <th style={{ width: "5%", textAlign: "left" }}>S.No</th>
              <th style={{ width: "15%", textAlign: "left" }}>Employee Name</th>
              <th style={{ width: "13%", textAlign: "left" }}>Employee Role</th>
            </tr>
          </thead>
          {paginatedData.length > 0 ? (
            <tbody>
              {paginatedData.map((row, index) => (
                <tr key={row.id}>
                  <td>
                    <input
                      type="radio"
                      name="employeeSelection"
                      value={row.id}
                      checked={selectedEmployee.userId === row.id}
                      onChange={() => handleEmployeeSelection(row)}
                      className="mt-2"
                    />
                  </td>
                  <td>{currentPage * rowsPerPage + index + 1}</td>
                  <td>
                    {row.name.length > 15 ? (
                      <Tooltip
                        placement="top"
                        overlay={
                          <div style={{ wordBreak: "break-word" }}>
                            {row.name}
                          </div>
                        }
                        overlayClassName="timeoff-calender-tooltip"
                      >
                        <span style={{ display: "inline-block" }}>
                          {row.name.substring(0, 15)}...
                        </span>
                      </Tooltip>
                    ) : (
                      row.name
                    )}
                  </td>
                  <td>{row.role}</td>
                </tr>
              ))}
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td colSpan="4" style={{ textAlign: "center" }}>
                  No matching records found for your search.
                </td>
              </tr>
            </tbody>
          )}
        </table>
      </div>{" "}
      {employeeList.length > 10 && (
        <div className="d-flex justify-content-between pt-4 px-3 pb-0">
          <div>
            <select value={rowsPerPage} onChange={handleRowsPerPageChange}>
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={30}>30</option>
              <option value={50}>50</option>
            </select>
          </div>
          <div>
            {currentPage !== 0 && (
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                className="non-active-pagination-btn"
              >
                &lt;
              </button>
            )}
            {Array.from({ length: totalPages }, (_, i) => i).map((page) => (
              <button
                key={page}
                disabled={currentPage === page}
                onClick={() => handlePageChange(page)}
                className={
                  currentPage === page
                    ? "active-pagination-btn"
                    : "non-active-pagination-btn"
                }
              >
                {page + 1}
              </button>
            ))}
            {currentPage !== totalPages - 1 && (
              <button
                onClick={() => handlePageChange(currentPage + 1)}
                className="non-active-pagination-btn"
              >
                &gt;
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
